import axios from 'axios';
import setAuthToken from '../utils/setAuthToken';
import { setAlert } from './alert';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Add cans manually by admin
export const addCansManually = (data) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }

    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        const res = await axios.post(`${API_URL}/cans/add-cans`, data, config);
        if (res.data?.success) {
            dispatch(setAlert(res.data.message || 'Cans added successfully', 'success'));
        } else {
            const errorMessage = res.data?.error || 'Failed to add cans';
            dispatch(setAlert(errorMessage, 'danger'));
        }
        return res.data;
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to add cans';
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Remove cans manually by admin
export const removeCansManually = (data) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }

    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        const res = await axios.post(`${API_URL}/cans/remove-cans`, data, config);
        if (res.data?.success) {
            dispatch(setAlert(res.data.message || 'Cans removed successfully', 'success'));
        } else {
            const errorMessage = res.data?.error || 'Failed to remove cans';
            dispatch(setAlert(errorMessage, 'danger'));
        }
        return res.data;
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to remove cans';
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};


